<template>
    <div v-if="client">
        <!-- home route -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Home route</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.routing.homeRoute"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- authentication route -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Authentication route</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.routing.authenticationRoute"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- registration path -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Registration path</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.routing.registrationPath"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- redirect to deposit after registration -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Redirect to deposit after registration</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.routing.redirectToDepositAfterRegistration"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';

export default {
    name: 'client-settings-view-routing',
    components: { ContentStringRef },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/routing.vue